module.exports = __webpack_public_path__ + "img/courier-default.7b311986.svg";